import { Intent, Position, Toaster } from "@blueprintjs/core";

// App-wide notifications. Styles: styles/feedback.scss (.app-toast).
//
// Callers pass whatever icon they like (thumbs-up, warning-sign, tick…); for
// one look everywhere the icon follows the intent instead: a tick for success,
// an error mark for a failure, a warning sign for a warning, an info mark
// otherwise. An icon that says something specific (envelope, arrow-up…) is kept.
const toaster = Toaster.create({
  position: Position.TOP,
  className: "app-toaster",
});

const GENERIC_ICONS = ["thumbs-up", "thumbs-down", "tick", "tick-circle", "warning-sign", "error", "info-sign", "issue"];

const ICON_FOR_INTENT = {
  [Intent.SUCCESS]: "tick-circle",
  [Intent.DANGER]: "error",
  [Intent.WARNING]: "warning-sign",
  [Intent.PRIMARY]: "info-sign",
};

const withHouseStyle = (props = {}) => {
  const icon = !props.icon || GENERIC_ICONS.includes(props.icon)
    ? ICON_FOR_INTENT[props.intent] || "info-sign"
    : props.icon;
  return {
    timeout: 4000,
    ...props,
    icon,
    className: `app-toast${props.className ? ` ${props.className}` : ""}`,
  };
};

const Toast = {
  show: (props, key) => toaster.show(withHouseStyle(props), key),
  dismiss: (key) => toaster.dismiss(key),
  clear: () => toaster.clear(),
  getToasts: () => toaster.getToasts(),
};

export default Toast;
